import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './utils/format.js';

// 引入自定义的样式文档
import '@/styles/html.scss';
import '@/styles/customer.scss';
import '@/styles/liu.scss';
import '@/styles/mintui.scss';
import '@/styles/echarts.scss';
import '@/styles/manage.scss';
import '@/styles/businesser.scss';

// 引入ajax交互组件
import axios from 'axios';
Vue.prototype.$axios = axios;

// 引入svg图片
import '@/assets/icons';

// 引入mint-ui组件
import MintUI from 'mint-ui';
import 'mint-ui/lib/style.css';
Vue.use(MintUI);

// 引入element-ui组件
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// 引入title
import VueWechatTitle from 'vue-wechat-title';
Vue.use(VueWechatTitle);

// 2022.3.1 引入剪切板功能
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);

Vue.config.productionTip = false;

// 2022.2.18 自动进件商户管理模块公共变量组件
import posManageModule from '@/components/PosManageModule';
Vue.prototype.POS_MANAGE_MODULE = posManageModule;

// 跳转页面
Vue.prototype.pushPage = function (val, paramter = {}) {
  this.$router.push({
    path: `/${val}`,
    query: paramter,
  });
};
// 跳转页面
Vue.prototype.replacePage = function (val, paramter = {}) {
  this.$router.replace({
    path: `/${val}`,
    query: paramter,
  });
};

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
